package org.moxultimate.topwithmox.apps.ui

import androidx.compose.runtime.Immutable
import org.moxultimate.topwithmox.apps.data.AppsResponse

/**
 * AppsState
 * Screen states for the Apps & Games page driven by [AppsViewModel].
 */
@Immutable
sealed class AppsState {
    data object Loading : AppsState()
    data class Error(val error: String, val statusCode: Int = 0) : AppsState()
    data class Success(
        val appsList: List<AppsResponse>,
        val hasMore: Boolean = true,
    ) : AppsState()
}
